import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import useFetchSiteSettings from './useFetchSiteSettings';
const useDomainLanguage = ({
  skipFetch
}) => {
  const {
    loading,
    error,
    siteSettings
  } = useFetchSiteSettings({
    skip: skipFetch
  });
  const getDomainLanguage = crmObject => {
    var _siteSettings$bodyOve;
    const domain = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_DOMAIN);
    return siteSettings === null || siteSettings === void 0 || (_siteSettings$bodyOve = siteSettings.bodyOverrideByDomain) === null || _siteSettings$bodyOve === void 0 || (_siteSettings$bodyOve = _siteSettings$bodyOve[domain]) === null || _siteSettings$bodyOve === void 0 ? void 0 : _siteSettings$bodyOve.contentLanguage;
  };
  return {
    loading,
    error,
    getDomainLanguage
  };
};
export default useDomainLanguage;